import { $ as $a1ea59d68270f0dd$export$f8168d8dd8fd66e6 } from '../../interactions/dist/useFocus-rl23fSDz.js';
import { $ as $507fabe10e71c6fb$export$b9b3dfddab17db27, a as $507fabe10e71c6fb$export$ec71b4b83ac08ec3 } from '../../interactions/dist/useFocusVisible-BD0kxHgk.js';
import { $ as $9ab94262bd0047c7$export$420e68273165f4ec } from '../../interactions/dist/useFocusWithin-CeckwKOJ.js';
import { useRef, useState, useCallback } from 'react';

function $f7dceffc5ad7768b$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || ($507fabe10e71c6fb$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    ($507fabe10e71c6fb$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = ($a1ea59d68270f0dd$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}

export { $f7dceffc5ad7768b$export$4e328f61c538687f as $ };
//# sourceMappingURL=useFocusRing-CaK43saz.js.map
